import { observer } from 'mobx-react-lite';
import SelectedContainer from './SelectedContainer';
import type { SelectedContainerProps, SelectedContainerValueProps } from './types';

export type { SelectedContainerProps, SelectedContainerValueProps };
export default observer(SelectedContainer); // MANUAL OVERRIDE
